<template>
  <div id="wrapper-app">
    <router-view />

    <b-alert
      :show="error.dismissCountDown"
      class="position-fixed fixed-bottom m-0 rounded-0"
      style="z-index: 2000"
      variant="danger"
      dismissible
      fade
      @dismissed="error.dismissCountDown = 0"
      @dismiss-count-down="error.dismissCountDown = $event"
    >
      {{ error.message }}
    </b-alert>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js'
import { mapActions } from 'vuex'
import { BroadcastChannel } from 'broadcast-channel'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  name: 'app',
  mixins: [lmToasts],
  provide: {
    lumbredocs_v3: process?.env?.VUE_APP_LUMBREDOCS_V3 === 'yes'
  },
  data () {
    return {
      error: {
        dismissSecs: 5,
        dismissCountDown: 0,
        message: 'Ocurrio un error'
      }
    }
  },
  methods: {
    ...mapActions('settings', ['getCoreSettings', 'getHomeSettings']),

    defineBroadcastChannels () {
      const channel = new BroadcastChannel('logout')

      channel.onmessage = async event => {
        if (event && location.pathname !== '/login') {
          await channel.close()
          location.href = '/login'
        }
      }
    }
  },
  created () {
    this.getCoreSettings()
    this.getHomeSettings()
    this.defineBroadcastChannels()

    // TODO. este listener podria deprecarse y usar las toasts del mixin
    // En proceso de deprecarlo se eliminio de todas las vistas, solo quedo en
    // RemitosNewOrEdit.vue
    EventBus.$on('lmShowGlobalToast', (args = {}) => {
      const {
        toastMessage,
        toastAttributes
      } = args
      this.$bvToast.toast(toastMessage, toastAttributes)
    })

    EventBus.$on('onError', error => {
      if (!error.quotaError) {
        this.lmModalDangerMessage({
          btnText: this.$t('try_again'),
          resultSubtitle: this.$t('talk_to_admin'),
          message: error.message
        })
      } else {
        this.lmModalInformationMessage({
          message: error.quotaMessage,
          resultSubtitle: error.message,
          buttons: [
            {
              btnText: this.$t('close'),
              btnType: 'danger'
            },
            {
              btnText: this.$t('view_more'),
              btnCallback: async () => {
                this.$router.push('/ajustes?tab=1')
              }
            }
          ]
        })
      }
    })
  }
}
</script>

<style>
html body {
    background: #fff;
    color: #000; /* Reemplaza $primaryFontThemeColor */
    font-size: 14px;
    font-family: Nunito, sans-serif;
    overflow-x: hidden;
  }

  i, i::after, i::before {
    vertical-align: middle;
  }

  input, textarea, select {
    font-family: inherit;
    font-size: inherit;
  }

  .custom-select__all-border-radious {
    border-radius: 0.25rem !important;
  }

  /* Animation */
  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    transition: opacity 0.5s;
  }

  .fade-leave-active {
    transition: opacity 0.5s;
    opacity: 0;
  }

  canvas {
    max-width: 100%;
    height: auto;
  }

  a, .btn-link, button {
    transition: all 0.5s;
  }

  a:hover, .btn-link:hover, button:hover {
    transition: all 0.5s;
  }

  .badge-danger {
    background-color: #fa5c7c;
  }

  .btn-outline-light {
    color: #e3eaef;
    background-color: transparent;
    background-image: none;
    border-color: #e3eaef;
  }

  .hv-100 {
    height: 100vh;
  }

  .mhv-100 {
    min-height: 100vh;
  }

  .text-muted {
    color: #aaa !important; /* Reemplaza $mutedFontThemeColor */
  }

  .text-success {
    color: #0acf97 !important;
  }

  .clickable {
    cursor: pointer;
  }

  .handle {
    cursor: grab;
  }

  .not-allowed {
    cursor: not-allowed;
  }

  .lm-oveflow-visible {
    overflow: visible;
  }

  ul {
    padding: 0;
  }

  ul li {
    list-style: none;
  }

  ul li a:focus {
    border: 0;
    outline: none;
  }

  .h3, h3 {
    font-size: 24px;
  }

  .h4, h4 {
    font-size: 18px;
  }

  .h5, h5 {
    font-size: 15px;
  }

  .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    margin: 7px 0 10px 0;
    font-weight: 700;
    color: inherit;
  }

  a:hover, .btn-link:hover {
    text-decoration: none;
  }

  a:focus, .btn-link:focus {
    text-decoration: none;
  }

  .btn-secondary {
    box-shadow: 0 2px 6px 0 rgba(108, 117, 125, 0.5);
  }

  .menu-arrow::before {
    content: "\F142";
  }

  #ddown-header .btn {
    background-color: white;
    min-width: 170px;
    height: 60px;
  }

  #ddown-header .btn:focus {
    box-shadow: none;
  }

  #notification-header .btn {
    background: transparent;
    padding: 3px 0 0 0;
    color: #aaa; /* Reemplaza $mutedFontThemeColor */
    min-width: 32px;
    display: block;
    text-align: center;
    margin: 0 12px;
  }

  #notification-header .btn:focus {
    box-shadow: none;
  }

  #notification-header .dropdown-menu {
    width: 100%;
    left: 0;
    right: 0;
    margin: auto;
    padding: 0;
    max-height: 500px;
    overflow: auto;
  }

  #notification-header .list-group {
    max-height: 500px;
  }

  .wrapper-content-with-toolbar {
    padding: 0 95px 0 31px !important;
    width: 100% !important;
    margin-bottom: 130px;
  }

  .wrapper-content .page-title {
    font-size: 18px;
    margin: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 700;
    color: #000; /* Reemplaza $primaryFontThemeColor */
  }

  hr {
    margin: 1.1em 0px !important;
  }

  .wrapper-content {
    padding: 0 24px 0 31px;
    width: 100% !important;
    margin-bottom: 130px;
  }

  .btn {
    font-size: 14px;
  }

  .btn:disabled {
    cursor: not-allowed;
  }

  .btn-primary:focus {
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  }

  .btn-light {
    box-shadow: 0 2px 6px 0 rgba(227, 234, 239, 0.5);
  }

  .btn-light:focus {
    box-shadow: 0 0 0 0.2rem rgba(227, 234, 239, 0.5);
  }

  .card {
    border: 1px solid rgba(152, 166, 173, 0.3);
    border-radius: 0.5rem;
    box-shadow: 0px 1px 2px 0px #eff2f5 !important;
    margin-bottom: 30px;
  }

  .card .header-title {
    text-transform: uppercase;
    letter-spacing: 0.28px;
    font-size: 14px;
    margin-top: 0;
  }

  .card .card-body {
    padding: 24px;
  }

  .lm-charts canvas {
    padding: 24px;
    border: none;
    box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
    margin-bottom: 30px;
  }

  .lm-loader::after {
    content: '';
    position: absolute;
    background-image: url('/assets/images/LmComponentLoading.svg');
    z-index: 10;
    top: 0;
    bottom: 30px;
    left: 15px;
    right: 15px;
    margin: auto;
    max-width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-color: white;
  }

  .btn-link:hover {
    text-decoration: none;
    background-color: transparent;
    border-color: transparent;
  }

  .wrapper-title-page {
    min-height: 85px;
  }

  .page-item.active .page-link {
    z-index: 1;
    color: #fff;
  }

  .page-link {
    border-radius: 30px !important;
    margin: 0 1px;
    border: none;
    position: relative;
    display: block;
    padding: 6px 11px;
    line-height: 1.25;
    color: #313a46;
    background-color: #fff;
  }

  .dataTables_wrapper .dataTables_paginate {
    margin: 0;
    white-space: nowrap;
    text-align: right;
  }

  .dataTables_wrapper .dataTables_paginate ul.pagination {
    margin: 2px 0;
    white-space: nowrap;
    justify-content: flex-end;
  }

  .dataTables_wrapper .datatable-buttons_info {
    font-weight: 600;
  }

  .dataTables_wrapper .dataTables_filter {
    text-align: right;
  }

  .dataTables_wrapper .dataTables_filter label {
    font-weight: normal;
    white-space: nowrap;
    text-align: left;
  }

  .dataTables_wrapper .dataTables_filter label input {
    margin-left: 0.5em;
    display: inline-block;
    width: auto;
  }

  @supports (position: sticky) {
    .table.b-table.table-striped > tbody > tr:nth-of-type(odd) > .table-b-table-default {
      background: #f1f3fa;
    }
  }

  .table-striped {
    margin-top: 6px;
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: #f1f3fa;
  }

  table.dataTable {
    border-collapse: collapse !important;
    margin-bottom: 15px !important;
  }

  table.dataTable thead tr th:not(:first-child) {
    display: none;
  }

  div.dt-buttons {
    margin-bottom: 24px;
  }

  div.dt-buttons .custom-select:disabled {
    opacity: 0.65;
    border-color: #007bff;
    background-color: #007bff;
    color: white;
  }

  #wrapper-LmTableList .wrapper-table-pagination .pagination-md li {
    display: inline-block !important;
  }

  .app-search {
    padding: 0;
    overflow: hidden;
    float: left;
  }

  .app-search button {
    font-size: 14px;
  }

  .app-search form {
    max-width: 320px;
  }

  .app-search .input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
  }

  .app-search .app-search__main-input {
    border: none;
    height: 38px;
    padding-left: 40px;
    padding-right: 20px;
    background-color: #f1f3fa;
    box-shadow: none;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  .app-search .app-search__main-input::-webkit-input-placeholder {
    color: #c1c1c1;
    font-size: 14px;
  }

  .app-search .mdi-magnify {
    position: absolute;
    z-index: 9;
    font-size: 20px;
    line-height: 38px;
    left: 10px;
  }

  .app-search .input-group-append {
    margin-left: 0;
    z-index: 4;
  }

  .modal .modal-90-percent {
    max-width: 90%;
  }

  .avoid-pointer-events {
    pointer-events: none;
    cursor: not-allowed;
  }

  label small {
    color: #f03d37;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .noti-icon-badge {
    display: inline-block;
    position: absolute;
    top: 20px;
    right: 15px;
    border-radius: 50%;
    height: 10px;
    width: 10px;
    background-color: #fa5c7c;
  }

  .form-control[readonly] {
    background: white;
  }

  .form-control:disabled {
    cursor: not-allowed;
    background: #e9ecef;
  }

  .vue-dropzone > .dz-preview .dz-remove {
    margin: 0 auto;
    max-width: 90%;
    display: block;
    left: 0;
    right: 0;
  }

  .vue-dropzone > .dz-preview .dz-error-message {
    top: 0;
  }

  #fileModal .modal-dialog {
    height: 95%;
  }

  #fileModal .modal-dialog .modal-content {
    height: 95%;
  }

  .filter-lm-highlight-yellow {
    background-color: yellow;
  }

  #decretos-new-or-edit .dropzone .dz-preview,
  .lumbresign-document-new-or-edit .dropzone .dz-preview {
    display: none;
  }

  #decretos-new-or-edit .dropzone .dz-preview:last-child,
  .lumbresign-document-new-or-edit .dropzone .dz-preview:last-child {
    display: inline-block;
  }

  #decretos-new-or-edit .dropzone .dz-message,
  .lumbresign-document-new-or-edit .dropzone .dz-message {
    display: block;
  }

  #decretos-new-or-edit.hide-dz-success .dropzone .dz-success,
  .lumbresign-document-new-or-edit.hide-dz-success .dropzone .dz-success {
    display: none;
  }

  #decretos-new-or-edit.hide-dz-success .dropzone .dz-message,
  .lumbresign-document-new-or-edit.hide-dz-success .dropzone .dz-message {
    display: block;
  }

  .modal .modal-footer .btn {
    box-shadow: none; /* Reemplaza $button-shadow */
  }

  .b-pagination .page-link {
    border-radius: 50px !important;
  }

  table thead tr th:focus {
    outline: none;
  }

  .gap-1 {
    gap: 0.25rem;
  }

  .gap-2 {
    gap: 0.5rem;
  }

  .gap-3 {
    gap: 1rem;
  }

  .gap-4 {
    gap: 1.5rem;
  }

  .gap-5 {
    gap: 3rem;
  }

  .preview-iframe {
    min-height: 80vh;
  }

  .ant-steps-item-icon > .ant-steps-icon > i.anticon {
    position: relative;
    top: -1.5px;
  }

  .started-steps .ant-steps-item-icon,
  .started-steps .ant-steps-item-content {
    vertical-align: initial;
  }

  .ant-pagination-item-link svg {
    vertical-align: initial;
    position: relative;
    bottom: -1px;
  }

  .ant-table-thead .a-table-header-row > th {
    background-color: #79bfff36;
    padding: 0.75rem;
  }

  .ant-table .a-table-row > td {
    padding: 0.75rem;
  }

  .ant-table .a-table-row-disabled {
    background-color: #eaeaea;
  }

  .ant-table .a-table-row-removed {
    background-color: #ffe4e1;
  }

  .anticon {
    vertical-align: 0;
  }

  .ant-modal-confirm-content {
    margin: 0 !important;
  }

  .ant-modal-confirm-content .desc {
    margin-bottom: 20px;
  }

  #reamaze-widget {
    bottom: 46px !important;
    right: 23px !important;
    z-index: 500 !important;
    box-shadow: none !important;
  }

  #reamaze-widget-label {
    bottom: 44px !important;
    right: 84px !important;
    box-shadow: none !important;
  }

  #reamaze-wrapper {
    inset: auto 1rem 46px auto !important;
  }

  .buttons {
    position: fixed;
    bottom: 29px;
    width: 100% !important;
    padding-top: 10px;
    padding-bottom: 2px;
    z-index: 500;
    /* margin-left: -30px; */
    /* padding-left: 30px; */
    border-top: 1px solid rgba(152, 166, 173, 0.3);
    display: flex;
    gap: 1.1rem !important;
    background: #fff;
  }

  .btn {
    padding: 0.3rem 0.6rem !important;
    box-shadow: none !important;
  }

  .form-control, .vue-treeselect__control {
    border-radius: 0.5rem !important;
    box-shadow: 0px 1px 2px 0px #eff2f5 !important;
  }

  .form-group {
    margin-bottom: 0.93rem !important;
  }

  .ant-dropdown-menu {
    padding: 5px 0 0 0 !important;
  }

  .ant-dropdown-menu-item-active {
    background: #f6f6f6 !important;
  }

  .modal-footer {
    gap: 0.6rem !important;
  }

  .modal-footer .btn {
    padding: 0.4rem 0.6rem !important;
  }

  @media (max-width: 1199px) {
    /* Estilos para lg y menores */
    #ddown-header .btn {
      min-width: 0;
    }

    #ddown-header .dropdown-menu {
      width: 100%;
      transform: none !important;
      top: 100% !important;
      right: 0 !important;
      left: auto !important;
    }

    div.dt-buttons {
      text-align: center;
      float: none;
      width: 100%;
      display: inline-block;
    }

  }

  @media (max-width: 991px) {
    /* Estilos para md y menores */
    #reamaze-widget {
      right: 10px !important;
      bottom: 143px !important;
    }

    #reamaze-widget-label {
      bottom: 120px !important;
    }

    #reamaze-wrapper {
      width: calc(100% - 2em) !important;
      right: 1em !important;
    }

    .buttons {
      width: calc(100% + 10px) !important;
      overflow-x: auto;
      bottom: 63px;
      padding-bottom: 0px;
      margin-left: -30px;
      padding-left: 20px;
      padding-right: 15px;
    }

    .buttons .form-group {
      margin-bottom: 11px !important;
    }
  }

  @media (max-width: 767px) {
    .wrapper-content {
      padding: 0 0 0 0;
      /* padding: 0 2px 0 2px; */
    }
    /* Estilos para sm y menores */
    #notification-header .dropdown-menu {
      top: 75px !important;
      transform: initial !important;
    }

    #notification-header .dropdown-menu {
      top: 75px !important;
      right: 15px !important;
      left: auto !important;
      width: 320px;
    }

    .buttons {
      margin-left: initial;
    }
  }

  @media (max-width: 575px) {
    /* Estilos para xs */
    .wrapper-content-with-toolbar {
      padding: 0px 23px !important;
    }
  }
</style>
